import { track } from '@/lib/analytics';

interface HowItWorksSectionProps {
  onCtaClick?: () => void;
}

export const HowItWorksSection: React.FC<HowItWorksSectionProps> = ({ onCtaClick }) => {
  return (
    <section className="lp-process-section" id="process">
      <div className="lp-process-inner">
        <h2>So funktioniert Estage</h2>
        <div className="lp-process-card">
          <div className="lp-process-steps">
            {/* Step 1 */}
            <div className="lp-process-step">
              <div className="lp-process-step-image placeholder">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5m-13.5-9L12 3m0 0l4.5 4.5M12 3v13.5"/>
                </svg>
              </div>
              <div className="lp-process-step-number">01</div>
              <h3>Fotos hochladen</h3>
              <p>Lade deine Immobilienfotos hoch — JPEG, PNG oder direkt vom iPhone (HEIC).</p>
            </div>
            {/* Step 2 */}
            <div className="lp-process-step">
              <div className="lp-process-step-image lp-process-step-image--centered">
                <img src="/landing/ES_IMG_Web_Collage_Vorher-Nachher.webp" alt="Vorher-Nachher Vergleich" />
              </div>
              <div className="lp-process-step-number">02</div>
              <h3>KI generiert Varianten</h3>
              <p>Wähle Raumtyp und Stil. Die KI räumt leer oder richtet virtuell ein — in Sekunden.</p>
            </div>
            {/* Step 3 */}
            <div className="lp-process-step">
              <div className="lp-process-step-image lp-process-step-image--bottom">
                <img src="/landing/ES_IMG_Web_Overlay_orange.webp" alt="Overlay hinzufügen" />
              </div>
              <div className="lp-process-step-number">03</div>
              <h3>Overlay hinzufügen</h3>
              <p>Füge ein individuelles Overlay hinzu, so wie es auf den Plattformen zu sehen sein soll.</p>
            </div>
            {/* Step 4 */}
            <div className="lp-process-step">
              <div className="lp-process-step-image">
                <div className="lp-process-export-ui">
                  <div className="lp-process-export-thumbs">
                    <img src="/landing/ES_IMG_Web_Wohnzimmer1_modern.webp" alt="" />
                    <img src="/landing/ES_IMG_Web_Wohnzimmer1_industrial.webp" alt="" />
                  </div>
                  <div className="lp-process-export-btn">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M8.25 12l3.75 3.75 3.75-3.75M12 3v13.5"/>
                    </svg>
                    Bilder downloaden
                  </div>
                </div>
              </div>
              <div className="lp-process-step-number">04</div>
              <h3>Exportieren</h3>
              <p>Branding anwenden, Bilder herunterladen und direkt in Exposés oder Portalen nutzen.</p>
            </div>
          </div>
        </div>
        <div className="lp-process-cta">
          <button className="lp-btn-primary inline" onClick={() => { track('Landing CTA Clicked', { location: 'how_it_works' }); onCtaClick?.(); }}>
            Jetzt kostenlos testen
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"/>
            </svg>
          </button>
          <p className="lp-process-cta-note">
            Registriere dich jetzt und erhalte <strong>10 Credits gratis</strong>.
          </p>
        </div>
      </div>
    </section>
  );
};
